export default __webpack_public_path__ + "static/media/gallery-wip-construction-improvements_00.de161ef8.jpg";